import React from 'react';
import { Button, Eyebrow } from '../primitives';
import { CalendarDays } from '../icons';

/** PHLD.ai — Contact. One warm CTA → a booking link. Email + phone, quietly. */
export function Contact() {
  const section: React.CSSProperties = { background: 'var(--surface-canvas)' };
  const inner: React.CSSProperties = {
    maxWidth: '820px',
    margin: '0 auto',
    padding: 'var(--space-10) var(--gutter) var(--space-11)',
    textAlign: 'center',
  };
  const head: React.CSSProperties = {
    fontWeight: 'var(--weight-extralight)' as any,
    fontSize: 'clamp(2.2rem, 4.6vw, 3.75rem)',
    lineHeight: 1.08,
    letterSpacing: 'var(--tracking-display)',
    color: 'var(--text-strong)',
    margin: 'var(--space-5) auto 0',
    maxWidth: '16ch',
  };
  const sub: React.CSSProperties = {
    fontSize: 'var(--text-subtitle)',
    color: 'var(--text-muted)',
    margin: 'var(--space-6) auto 0',
    maxWidth: '40ch',
    lineHeight: 'var(--leading-normal)',
  };
  const meta: React.CSSProperties = {
    marginTop: 'var(--space-7)',
    display: 'flex',
    gap: 'var(--space-6)',
    justifyContent: 'center',
    flexWrap: 'wrap',
    color: 'var(--text-muted)',
    fontSize: 'var(--text-small)',
  };
  const a: React.CSSProperties = { color: 'var(--ink-700)', borderBottom: '1px solid var(--border-strong)', paddingBottom: '2px' };

  return (
    <section style={section} id="contact">
      <div style={inner}>
        <Eyebrow as="div" style={{ textAlign: 'center' }}>
          Let&apos;s talk
        </Eyebrow>
        <h2 style={head}>Let&apos;s talk, colleague to colleague.</h2>
        <p style={sub}>
          No pitch: a conversation, colleague to colleague. You tell me how your house works; I&apos;ll
          show you what I&apos;d build, how it would run, and where I&apos;d start first.
        </p>
        <div style={{ marginTop: 'var(--space-7)', display: 'flex', justifyContent: 'center' }}>
          <Button size="lg" href="https://scheduler.zoom.us/olesya-tarasova/phld-ai-olesya-tarasova" icon={<CalendarDays size={18} />}>
            Let&apos;s talk
          </Button>
        </div>
        <div style={meta}>
          <a href="mailto:tarasova@phld.fr" style={a}>
            tarasova@phld.fr
          </a>
          <a href="tel:+33751620694" style={a}>
            +33 7 51 62 06 94
          </a>
        </div>
      </div>
    </section>
  );
}
